export default __webpack_public_path__ + "static/media/OCGO-slider6.06b1e56c.jpg";